import { createStore } from 'satcheljs';
import type ImmersiveReaderStore from './schema/ImmersiveReaderStore';
import { getGuid } from 'owa-guid';

const initialImmersiveReaderStore: ImmersiveReaderStore = {
    sessionId: getGuid(),
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (14,5): Type 'null' is not assignable to type 'string'.
    // @ts-expect-error
    token: null,
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (18,5): Type 'null' is not assignable to type 'string'.
    // @ts-expect-error
    subdomain: null,
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (22,5): Type 'null' is not assignable to type 'Date'.
    // @ts-expect-error
    tokenExpiry: null,
};

const store = createStore<ImmersiveReaderStore>('immersivereader', initialImmersiveReaderStore)();
export default store;
export const getStore = () => store;
